/**
 * Utility functions for API parameter handling
 */

/**
 * Serialize filter params for Django REST Framework pagination.
 * Converts arrays to comma-separated strings, omits empty/null values.
 *
 * @example
 * // Arrays → comma-separated strings
 * serializeFilterParams({ status: ['Intake', 'Case Setup'], limit: 50 })
 * // → { status: 'Intake,Case Setup', limit: 50 }
 *
 * @example
 * // Single values pass through
 * serializeFilterParams({ status: 'Intake', limit: 50 })
 * // → { status: 'Intake', limit: 50 }
 */
export function serializeFilterParams(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params: any,
): Record<string, string | number | boolean> {
  const serialized: Record<string, string | number | boolean> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      // Skip undefined, null, and empty strings
      return;
    }

    if (Array.isArray(value)) {
      if (value.length > 0) {
        // Convert non-empty array to comma-separated string
        serialized[key] = value.map(String).join(',');
      }
      // Skip empty arrays
    } else if (
      typeof value === 'string' ||
      typeof value === 'number' ||
      typeof value === 'boolean'
    ) {
      // Preserve primitive values
      serialized[key] = value;
    }
    // Skip other types (objects, functions, etc.)
  });

  return serialized;
}
